<template>
  <div class="content-area" >
    <div class="content-box" v-if="allowflag == true">
      <ul class="graph-color-list">
        <li div v-if="this.source[0] != null"><font :style="{color:this.source[0].color}" size="5">{{ this.source[0].name }}</font></li>
        <li div v-if="this.source[1] != null"><font :style="{color:this.source[1].color}" size="5">{{ this.source[1].name }}</font></li>
      </ul>
      <Graph
        style="background-color: #EEEEEE; padding: 10px;"
        :source="this.source"
        :since="this.since"
        :until="this.until"
        ref="renderGraphRelative"
      />
      <div class="button_bar">
        <a
          v-if="this.source.length != 2"
          @click="downloadCSV"
          class="btn-square-little-rich"
        >
          <b-icon  icon="file-download"></b-icon>
          <span class="button_text">{{$t("general.download")}}</span>
        </a>
      </div>
      <Table
        v-if="this.source.length == 1 && this.source[0].plotdata != null"
        :plotdata="this.source[0].plotdata"
      />
    </div>
    <div class="content-box" v-else>
      <b-message type="is-danger" has-icon>
        <font size="5"><p>{{this.$t('app.dashboard.graph.allert_message3')}}</p></font>
        <font size="5"><p>{{this.$t('app.dashboard.graph.allert_message4')}}</p></font>
      </b-message>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import Graph from "../view/Graph";
import Table from "./dashboard/GraphPageTable";
import Vue from "vue";
import { mapActions } from "vuex"

export default {
  data() {
    return {
      limit: null,
      since: null,
      until: null,
      gstate: "public",
      allowflag: true,
      refreshflag: false,
      datamode: null,
      source: [],
      color: (function* getColor() {
        const colors = ["#333", "#428BCA", "#18A689", "#F1AE4E", "#C75858"]
        for (let i = 0; i < colors.length; i++) {
          yield colors[i]
        }
      })()
    };
  },
  components: {
    Graph,
    Table
  },
  beforeDestroy () {
    this.source = [],
    this.UpdateUserFlag(true)
  },
  watch: {
    refreshflag: function(){
      if(this.refreshflag == true){
        this.routing_render()
        this.refreshflag = false
      }
    }
  },
  mounted(){
    this.UpdateUserFlag(false)
    this.splitID().forEach(el => {
      return this.getVariable({vId: el, mode: "share"})
      .then(res => {
        Vue.set(this.source, this.source.length, {
          id: el,
          name: res.Name,
          color: this.color.next().value,
          plotdata: []
        })
      })
      .then(() => {
        this.routing_render()
      })
      .catch(() => { 
        this.$buefy.toast.open({
          duration: 7000,
          message: this.$t('app.dashboard.graph.error_warning'),
          position: "is-top",
          type: "is-danger"
        })
        this.allowflag = false
        return Promise.resolve()
      })
    });
  },
  methods: {
    splitID() {
      let prm = this.$route.params.graphID.split("?");
      let vIds = prm[0].split("&");
      vIds.shift();

      this.limit = Number(this.$route.query.count)

      if(this.$route.query.since == "null"){
        this.since = null
      }else{
        this.since = moment(Number(this.$route.query.since))
      }

      if(this.$route.query.until == "null"){
        this.until = null
      }else{
        this.until = moment(Number(this.$route.query.until))
      }

      if(this.$route.query.mode == undefined || this.$route.query.mode == null) {
        if(this.$route.query.minutes != null && this.$route.query.minutes != undefined) {
          if (this.$route.query.minutes == 0) {
            if (this.limit == 0) {
              this.datamode = "absolute_mode"
            }else {
              this.datamode = "limit_mode"
            }
          }else {
            this.datamode = "latest_mode"
          }
        }else{
          if (this.limit == 0) {
            this.datamode = "absolute_mode"
          }else {
            this.datamode = "limit_mode"
          }
        }
      }else {
        this.datamode = this.$route.query.mode
      }

      if(this.datamode == "latest_mode") {
        this.$store.dispatch("graph/setRelativeTime", Number(this.$route.query.minutes))
        this.since = this.$store.state.graph.options.since
        this.until = this.$store.state.graph.options.until
      }

      return vIds
    },
    transdate(iso8601String) {
        let date = new Date(iso8601String);
        return date.getFullYear() + "/" +
            (date.getMonth() + 1) + "/" +
            date.getDate() + " " +
            date.getHours() + ":" +
            date.getMinutes() + ":" +
            date.getSeconds();
    },
    downloadCSV() {
        if(this.showboolean == true && this.source.length == 1){
            var csv = "\ufeff";
            const data = this.source[0]
            
            for (let i = 0; i < data.plotdata.length; i++) {
                var line = this.transdate(data.plotdata[i]["x"]) + "," + data.plotdata[i]["y"] + "\n";
                csv += line;
            }
            let blob = new Blob([csv], { type: "text/csv" });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = data.name + ".csv";
            link.click();
        }
    },
    updateGraphData(limit, gstate) {
      let p = Promise.resolve();
      this.source.forEach((element, i) => {
        p.then(() => {
          return this.getData({
            vId: element.id,
            limit: limit,
            since: null,
            until: null,
            gstate: gstate
          })
          .catch((e) => { 
            if (e.message == '"data length is too large"\n') {
              this.er = e.message
              return Promise.resolve()
            } else {
              this.$buefy.toast.open({
                duration: 7000,
                message: this.$t('app.dashboard.graph.error_warning'),
                position: "is-top",
                type: "is-danger"
              })
              this.auto_flag = false
              return Promise.resolve()
            }
          })
          .then(respObj => {
            this.showboolean = true
            const data = respObj.Data.map(v => {
            return {
                y: v.Value,
                x: moment(v.Timestamp).tz("Asia/Tokyo").format()
            };
            })
            Vue.set(this.source, i, Object.assign(this.source[i], {plotdata: data}))
          });
        });
      });
      return p;
    },
    updateGraphData_span(since, until, gstate) {
      let p = Promise.resolve()
      this.source.forEach((element, i) => {
        p.then(() => {
          return this.getData({
            vId: element.id,
            limit: 0,
            since: since,
            until: until,
            gstate: gstate
          })
          .catch( (e) => { 
            if (e.message == '"data length is too large"\n') {
              this.er = e.message
              return Promise.resolve()
            } else {
              this.$buefy.toast.open({
                duration: 7000,
                message: this.$t('app.dashboard.graph.error_warning'),
                position: "is-top",
                type: "is-danger"
              })
              this.auto_flag = false
              return Promise.resolve()
            }
          })
          .then(respObj => {
            if(this.er == '"data length is too large"\n'){
                this.showboolean = false
                this.source.forEach(element => {
                    element.plotdata = null
                });
                this.er = null
                return "error"
            }else{
                this.showboolean = true
                const data = respObj.Data.map(v => {
                    return {
                        y: v.Value,
                        x: moment(v.Timestamp).tz("Asia/Tokyo").format()
                    };
                })
                Vue.set(this.source, i, Object.assign(this.source[i], {plotdata: data}))
            }
          });
        });
      });
      return p;
    },
    routing_render(){
      if(this.datamode == "limit_mode"){
        this.updateGraphData(this.limit, this.gstate)
      }else if(this.datamode == "latest_mode" || this.datamode == "absolute_mode"){
        this.updateGraphData_span(this.since, this.until, this.gstate)
      }
      this.refreshflag = true
    },
    /*
    sleep(msec) {
      return new Promise(function(resolve) {
          setTimeout(function() {resolve()}, msec);
      })
    },
    async start() {
        await this.sleep(50) //ここで描画後に何ミリ秒待ってから再描画するかを決める
        this.routing_render()
    },
    */
    ...mapActions({
      getData: "variables/getData",
      getVariable: "variables/getVariable",
      UpdateUserFlag: "UpdateUserFlag"
    }),
  }
};
</script>
<style scoped>
.content-area {
  padding: 35px 5% 80px;
  width: 100%;
  height: 100%;
  background: #f5f5f5;
}
.white-box-time {
  background-color: #fff;
  padding-bottom: 20px;
  height: 150px;
}
.white-box-graph {
  background-color: #fff;
  padding: 40px;
}
.graph{
  background-color: #EEEEEE;
  padding: 20px;
}
.button_bar{
  text-align:center;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.btn-square-little-rich {
  position: relative;
  display: inline-block;
  padding: 10px 5px;
  text-decoration: none;
  color: #FFF;
  background:#2c6ac4;/*色*/
  border: solid 1px #2c6ac4;/*線色*/
  border-radius: 4px;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.2);
  text-shadow: 0 1px 0 rgba(0,0,0,0.2);
  margin: 10px 15px;
  width: 160px;
  height: 50px;
}
.btn-square-little-rich:active {
  /*押したとき*/
  border: solid 1px #2c6ac4;
  box-shadow: none;
  text-shadow: none;
}
.button_text{
  padding: 30px 10px;
}
.graph-color-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 10px;
}
.graph-color-list li {
  margin: .5em;
  font-size: 2rem;
  font-weight: bold;
}
.content-box {
  text-align: center;
  width: 100%;
  background: #fff;
  margin: 20px 0;
  padding: 30px;
  border-radius: 4px;
  border: 1px solid #ccc;
}
.allert_box{
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    background-color: #EEEEEE; 
    padding: 10px;
    height: 420px;
    width: 50%;
}
</style>
